import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Card from '../../components/base/Card';
import Button from '../../components/base/Button';

export default function Noticias() {
  const navigate = useNavigate();
  const [selectedNews, setSelectedNews] = useState<any>(null);

  const allNews = [
    {
      id: 1,
      title: 'Tecnutri Food Service lança nova linha de embalagens',
      excerpt: 'A Tecnutri Food Service anuncia o lançamento de sua nova linha de embalagens sustentáveis, desenvolvidas especialmente para o mercado de food service. As novas embalagens chegam aos pontos de venda em maio e prometem revolucionar o setor.',
      content: 'A nova linha de embalagens da Tecnutri Food Service foi desenvolvida com foco na sustentabilidade e praticidade. Feitas com materiais recicláveis e biodegradáveis, as embalagens mantêm a qualidade dos produtos por mais tempo, garantindo frescor e sabor. A linha inclui diferentes tamanhos e formatos para atender às necessidades específicas de cada estabelecimento. O investimento em pesquisa e desenvolvimento resultou em embalagens que reduzem o impacto ambiental em até 40% comparado às versões anteriores. Além disso, o novo design facilita o armazenamento e transporte, otimizando a logística dos clientes.',
      date: '2025',
      author: 'Equipe Tecnutri',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/45f08a0bd56550322d746edcb3eacbb0.jpeg'
    },
    {
      id: 2,
      title: 'Metodologia de treinamento Tecnutri Food Service do Brasil',
      excerpt: 'A Tecnutri quer ser mais que uma simples fornecedora de produtos, queremos ser sua parceira no desenvolvimento do seu negócio.',
      content: 'A Tecnutri Food Service realiza treinamentos especializados com clientes do setor food service em todo o Brasil. Nosso objetivo é ir além do fornecimento de produtos e estabelecer uma verdadeira parceria no desenvolvimento dos negócios de nossos clientes. Os treinamentos abrangem técnicas de preparo.&nbsp;gaps:•Entender as principais dificuldades dos vendedores, recorrentes dos clientes na ponta.Estrutura flexível e adaptável:•Adaptável às necessidades específicas do distribuidor, garantindo um aprendizado mais direcionado.Fortalecimento da argumentação de vendas:•Os treinamentos vão além da transmissão de informação técnica, com argumentos e técnicas&nbsp;universais de vendas, que melhoram a performance comercial.Feedback contínuo e materiais de apoio:•A estrutura que permite uma devolutiva baseada em dados coletados, proporcionando&nbsp;&nbsp;melhorias como rotas de vendas acompanhada e materiais de suporte.Otimização de processos, controle de qualidade e inovação no cardápio. Nossa equipe de especialistas compartilha conhecimento prático e teórico para maximizar o potencial dos produtos Tecnutri em cada estabelecimento. Acreditamos que o sucesso dos nossos clientes é também o nosso sucesso.',
      date: '2025',
      author: 'Departamento de Marketing',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/3c0ffeff534a41ec2d99aa8fb82a3dae.png'
    },
    {
      id: 3,
      title: 'Novo Amaciante de Carnes Tecnutri',
      excerpt: 'Revolucionário produto amacia até 34 Kg de carne, proporcionando maciez excepcional e reduzindo significativamente o tempo de preparo em cozinhas profissionais.',
      content: 'O Amaciante de Carnes Tecnutri representa um avanço tecnológico no setor de food service. Com fórmula concentrada e eficiente, um único produto é capaz de amaciar até 34 kg de carne, garantindo textura perfeita e sabor preservado. Desenvolvido especialmente para cozinhas profissionais que buscam qualidade e produtividade. O produto utiliza enzimas naturais que quebram as fibras da carne de forma controlada, resultando em maciez uniforme sem comprometer o sabor original.',
      date: '30 Mai 2025',
      author: 'Equipe Técnica',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/7990412b4ff85a490895778729573844.jpeg'
    },
    {
      id: 4,
      title: 'Tecnutri expande linha com Farinha Panko e Mistura para Tempurá',
      excerpt: 'Nova coleção de temperos artesanais desenvolvida especialmente para chefs profissionais, com blends exclusivos e ingredientes premium.',
      content: 'A Tecnutri Food Service expande seu portfólio com o lançamento da linha Farinha Panko e Mistura para Tempurá, desenvolvida para atender às exigências do food service profissional. Elaborados com alto padrão de qualidade, os produtos garantem empanados mais leves, crocantes e com excelente aderência, valorizando a textura e o sabor dos alimentos. Ideais para preparações como carnes, aves, peixes, frutos do mar e vegetais, a Farinha Panko e a Mistura para Tempurá proporcionam padronização, rendimento e resultados consistentes, elevando o nível das receitas e a experiência gastronômica no serviço profissional.',
      date: '15 Jun 2024',
      author: 'Chef Consultor',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/d59dfda5398841f721b04731a8533a9c.jpeg'
    },
    {
      id: 5,
      title: 'Parceria estratégica com distribuidores regionais',
      excerpt: 'Tecnutri anuncia expansão nacional através de parcerias com principais distribuidores do país, ampliando alcance e disponibilidade dos produtos.',
      content: 'A Tecnutri Food Service firmou parcerias estratégicas com os principais distribuidores regionais do Brasil, garantindo maior capilaridade e disponibilidade de seus produtos em todo território nacional. Esta expansão permitirá que mais estabelecimentos tenham acesso às soluções inovadoras da marca, fortalecendo o setor de food service brasileiro. As parcerias abrangem todas as regiões do país e incluem centros de distribuição estrategicamente localizados para otimizar a logística e reduzir custos de transporte.',
      date: '08 Ago 2024',
      author: 'Diretoria Comercial',
      image: 'https://readdy.ai/api/search-image?query=modern%20food%20distribution%20warehouse%20with%20trucks%20loading%2C%20logistics%20operation%2C%20professional%20food%20service%20industry%2C%20organized%20storage%20facility%2C%20business%20partnership%20concept&width=800&height=400&seq=news5&orientation=landscape'
    },
    {
      id: 6,
      title: 'Certificação de qualidade',
      excerpt: 'Tecnutri conquista certificação IFS Progres Food, reforçando compromisso com segurança alimentar e qualidade dos produtos oferecidos ao mercado.',
      content: 'A Tecnutri Food Service obteve a prestigiosa certificação ISO 22000, que atesta os mais altos padrões de segurança alimentar e gestão de qualidade. Esta conquista reforça o compromisso da empresa com a excelência e segurança de seus produtos, garantindo tranquilidade aos clientes e consumidores finais. O processo de certificação envolveu auditoria rigorosa de todos os processos produtivos, desde a seleção de matérias-primas até a distribuição final.',
      date: '12 Set 2024',
      author: 'Departamento de Qualidade',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/ef1200087bbb0c95ad6422973f58f646.png'
    },
    {
      id: 7,
      title: 'Linha de molhos Tecnutri',
      excerpt: 'Tecnutri apresenta nova linha de molhos food service desenvolvidas para elevar o padrão gastronômico de restaurantes e estabelecimentos comerciais.',
      content: 'A nova linha de molhos da Tecnutri foi criada para atender à crescente demanda por produtos de alta qualidade no mercado de food service. Com formulação exclusivas e ingredientes de qualidade, os molhos oferecem sabores únicos e consistência perfeita. A linha inclui molhos para massas, carnes e pratos especiais. Cada molho passou por processo de desenvolvimento para manter o padrão dos sabores, com testes em restaurantes parceiros para garantir aceitação e qualidade superior.',
      date: '18 Out 2025',
      author: 'Chef de Desenvolvimento',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/ce8195187de2b151b1866ff1fdffbf10.jpeg'
    },
    {
      id: 8,
      title: 'Programa de sustentabilidade Tecnutri Verde',
      excerpt: 'Iniciativa pioneira da Tecnutri visa reduzir impacto ambiental através de práticas sustentáveis em toda a cadeia produtiva e logística.',
      content: 'O selo eureciclo é um símbolo que demonstra o compromisso das marcas com a reciclagem, comunicando de forma clara o seu investimento para fortalecer a cadeia, gerar impacto socioambiental positivo e garantir o cumprimento da logística reversa. O selo certifica que a empresa realiza a logística reversa de suas embalagens em todo o território nacional, junto a cooperativas e operadores homologados pela eureciclo, que reciclam uma quantidade de material equivalente à das embalagens vendidas pela marca.',
      date: '25 Nov 2024',
      author: 'Departamento de Sustentabilidade',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/4d8aa6c65fec6b8af7aac0e562dc1496.png'
    }
  ];

  const handleImageClick = (article: any) => {
    setSelectedNews(article);
  };

  const closeModal = () => {
    setSelectedNews(null);
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-r from-red-600 to-red-700">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
            Notícias Tecnutri
          </h1>
          <p className="text-xl text-white/90 max-w-3xl mx-auto">
            Fique por dentro de todas as novidades, lançamentos e inovações da Tecnutri Food Service
          </p>
        </div>
      </section>

      {/* News Grid */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {allNews.map((article) => (
              <Card key={article.id} hover className="group overflow-hidden">
                <div className="relative">
                  <div 
                    className="aspect-video overflow-hidden rounded-lg bg-gray-100 cursor-pointer"
                    onClick={() => handleImageClick(article)}
                  >
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                </div>
                
                <div className="mb-4">
                  <span className="text-sm text-gray-500">Por {article.author}</span>
                </div>
                
                <h2 className="font-bold text-2xl text-gray-900 mb-4 group-hover:text-red-600 transition-colors">
                  {article.title}
                </h2>
                
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {article.excerpt}
                </p>
                
                <div className="flex items-center justify-between">
                  <Button 
                    variant="outline" 
                    size="sm" 
                    className="group-hover:bg-red-600 group-hover:text-white group-hover:border-red-600"
                    onClick={() => handleImageClick(article)}
                  >
                    <i className="ri-eye-line mr-2"></i>
                    Leia Mais
                  </Button>
                  <div className="flex items-center space-x-4 text-gray-400">
                    <button className="hover:text-red-600 transition-colors">
                      <i className="ri-heart-line"></i>
                    </button>
                    <button className="hover:text-red-600 transition-colors">
                      <i className="ri-share-line"></i>
                    </button>
                  </div>
                </div>
              </Card>
            ))}
          </div>

          {/* Newsletter Section */}
          <div className="mt-20 bg-gray-50 rounded-2xl p-12 text-center">
            <h3 className="text-3xl font-bold text-gray-900 mb-4">
              Receba nossas novidades
            </h3>
            <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
              Cadastre-se em nossa newsletter e seja o primeiro a saber sobre lançamentos, promoções e novidades da Tecnutri
            </p>
            <form 
              className="max-w-md mx-auto flex gap-4"
              data-readdy-form
              onSubmit={async (e) => {
                e.preventDefault();
                const formData = new FormData(e.target as HTMLFormElement);
                const data = new URLSearchParams();
                data.append('email', formData.get('email') as string);
                
                try {
                  const response = await fetch('https://readdy.ai/api/form/d3m055a2otq89lvpsf40', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: data
                  });
                  
                  if (response.ok) {
                    alert('Cadastro realizado com sucesso! Você receberá nossas novidades em primeira mão.');
                    (e.target as HTMLFormElement).reset();
                  } else {
                    alert('Erro ao cadastrar. Tente novamente.');
                  }
                } catch (error) {
                  alert('Erro ao cadastrar. Verifique sua conexão e tente novamente.');
                }
              }}
            >
              <input
                type="email"
                name="email"
                placeholder="Seu e-mail"
                required
                className="flex-1 px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent"
              />
              <Button type="submit" variant="primary" className="px-8">
                <i className="ri-mail-send-line mr-2"></i>
                Cadastrar
              </Button>
            </form>
          </div>

          {/* Back Button */}
          <div className="text-center mt-16">
            <Button 
              variant="outline" 
              size="lg"
              onClick={() => navigate('/')}
              className="hover:bg-red-600 hover:text-white hover:border-red-600"
            >
              <i className="ri-arrow-left-line mr-2"></i>
              Voltar ao Início
            </Button>
          </div>
        </div>
      </section>

      {/* Modal */}
      {selectedNews && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
            <div className="relative">
              <button
                onClick={closeModal}
                className="absolute top-4 right-4 w-10 h-10 bg-white/90 rounded-full flex items-center justify-center hover:bg-white transition-colors z-10"
              >
                <i className="ri-close-line text-xl text-gray-600"></i>
              </button>
              
              <div className="aspect-video overflow-hidden rounded-t-2xl">
                <img
                  src={selectedNews.image}
                  alt={selectedNews.title}
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
            
            <div className="p-8">
              <div className="flex items-center gap-4 mb-6">
                <span className="bg-red-600 text-white px-3 py-1 rounded-lg text-sm font-medium">
                  {selectedNews.date}
                </span>
                <span className="text-gray-500">Por {selectedNews.author}</span>
              </div>
              
              <h1 className="text-3xl font-bold text-gray-900 mb-6">
                {selectedNews.title}
              </h1>
              
              <div className="prose prose-lg max-w-none">
                <p className="text-gray-700 leading-relaxed text-lg">
                  {selectedNews.content}
                </p>
              </div>
              
              <div className="flex items-center justify-between mt-8 pt-6 border-t border-gray-200">
                <div className="flex items-center space-x-4">
                  <button className="flex items-center gap-2 text-gray-600 hover:text-red-600 transition-colors">
                    <i className="ri-heart-line"></i>
                    <span>Curtir</span>
                  </button>
                  <button className="flex items-center gap-2 text-gray-600 hover:text-red-600 transition-colors">
                    <i className="ri-share-line"></i>
                    <span>Compartilhar</span>
                  </button>
                </div>
                
                <Button variant="outline" onClick={closeModal}>
                  Fechar
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}